/* repo/session */
import axios from "axios";

/**
 * Logout function - calls the backend to blacklist the current JWT token
 */
export async function logout(): Promise<any> {
  const apiEndpoint = process.env.DMG_HOST_ENDPOINT || '/';
  
  const response = await axios.post(`${apiEndpoint}/auth/logout`, {}, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': process.env.ApiProxyKey || '',
      'Authorization': `Bearer ${sessionStorage.getItem('access_token') || ''}`
    },
  });

  return response.data;
}
